import { languageQuery } from '@gig/magic-common';
import { __awaiter, __generator, __assign } from 'tslib';
import { magic } from '@gig/magic-sdk';

var EmbeddedMessagingService = /** @class */ (function () {
    function EmbeddedMessagingService(config) {
        this.config = config;
        this.user = null;
        this.isLoaded = false;
        this.scriptLoaded = false;
    }
    EmbeddedMessagingService.prototype.loadEmbeddedMessaging = function (inputUser) {
        return __awaiter(this, void 0, void 0, function () {
            var user, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = magic.session.getUser() || inputUser;
                        this.updateUserData(user);
                        if (this.isLoaded) {
                            console.warn('Embedded Messaging is already loaded.');
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        if (!!this.scriptLoaded) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.appendScript()];
                    case 2:
                        _a.sent();
                        this.scriptLoaded = true;
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.initEmbeddedMessaging()];
                    case 4:
                        _a.sent();
                        this.isLoaded = true;
                        return [4 /*yield*/, this.waitForEmbeddedMessagingReady()];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.launchChat()];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        err_1 = _a.sent();
                        console.error('Error loading Embedded Messaging:', err_1);
                        throw err_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    EmbeddedMessagingService.prototype.updateUserData = function (user) {
        this.user = user;
    };
    EmbeddedMessagingService.prototype.appendScript = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            script.src = _this.config.sdkUrl;
            script.onload = function () { return resolve(); };
            script.onerror = function () { return reject(new Error('Failed to load script.')); };
            document.body.appendChild(script);
        });
    };
    EmbeddedMessagingService.prototype.initEmbeddedMessaging = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lang;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, languageQuery()];
                    case 1:
                        lang = _a.sent();
                        if (typeof embeddedservice_bootstrap === 'undefined') {
                            throw new Error('Embedded Messaging bootstrap script is not loaded.');
                        }
                        embeddedservice_bootstrap.settings.language =
                            this.config.language || lang;
                        embeddedservice_bootstrap.settings.chatButtonPosition = '80px,20px';
                        embeddedservice_bootstrap.init(this.config.orgId, this.config.embeddedServiceName, this.config.baseURL, { scrt2URL: this.config.scrt2URL });
                        window.addEventListener('onEmbeddedMessagingReady', function () {
                            var _a;
                            if ((_a = _this.config) === null || _a === void 0 ? void 0 : _a.hiddenPrechatFields) {
                                embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(_this.config.hiddenPrechatFields);
                            }
                            if (_this.config.visiblePrechatFields || _this.user) {
                                var prechatFields = __assign({}, (_this.config.visiblePrechatFields || {}));
                                if (_this.user) {
                                    var _b = _this.user, firstName = _b.firstName, lastName = _b.lastName, email = _b.email;
                                    prechatFields._firstName = {
                                        value: firstName || '',
                                        isEditableByEndUser: true,
                                    };
                                    prechatFields._lastName = {
                                        value: lastName || '',
                                        isEditableByEndUser: true,
                                    };
                                    prechatFields._email = {
                                        value: email || '',
                                        isEditableByEndUser: true,
                                    };
                                }
                                embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields(prechatFields);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    EmbeddedMessagingService.prototype.waitForEmbeddedMessagingReady = function (maxAttempts, interval) {
        var _this = this;
        if (maxAttempts === void 0) { maxAttempts = 30; }
        if (interval === void 0) { interval = 500; }
        return new Promise(function (resolve, reject) {
            var checkReady = function (attempts) {
                if (attempts === void 0) { attempts = 0; }
                if (_this.isEmbeddedMessagingReady()) {
                    resolve();
                }
                else if (attempts < maxAttempts) {
                    setTimeout(function () { return checkReady(attempts + 1); }, interval);
                }
                else {
                    reject(new Error('Timeout waiting for Embedded Messaging to be ready.'));
                }
            };
            checkReady();
        });
    };
    EmbeddedMessagingService.prototype.isEmbeddedMessagingReady = function () {
        return (typeof embeddedservice_bootstrap !== 'undefined' &&
            embeddedservice_bootstrap.utilAPI &&
            typeof embeddedservice_bootstrap.utilAPI.launchChat === 'function');
    };
    EmbeddedMessagingService.prototype.launchChat = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isEmbeddedMessagingReady()) {
                            throw new Error('Embedded Messaging is not ready for chat launch.');
                        }
                        return [4 /*yield*/, embeddedservice_bootstrap.utilAPI.launchChat()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return EmbeddedMessagingService;
}());

export { EmbeddedMessagingService };
